import { useQuery } from '@tanstack/react-query';

import { PaymentsDashboardResponse, getProfessionalPaymentsDashboard } from '@website/services/stripe.service';

/**
 * Hook to fetch payment dashboard data for a professional.
 *
 * Includes:
 * - On-hold payments (PAYMENT_RECEIVED, waiting 48h claim period)
 * - Disputed bookings
 * - Payout-ready bookings
 * - Recent payouts (last 30 days)
 * - Stripe account status
 */
export function usePaymentsDashboard(professionalId: string | undefined) {
  return useQuery<PaymentsDashboardResponse>({
    queryKey: ['paymentsDashboard', professionalId],
    queryFn: () => getProfessionalPaymentsDashboard(professionalId!),
    enabled: !!professionalId,
    staleTime: 60 * 1000, // 1 minute
    refetchInterval: 5 * 60 * 1000 // Refresh every 5 minutes
  });
}
